var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 31.5,
    stroke: "#CDD1E0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_375_14598)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.1871 27.8271L34.6083 27.8262C33.7437 27.8262 33.043 28.5269 33.043 29.3914V35.646C33.043 36.5103 33.7437 37.2112 34.6082 37.2112H45.6338C44.4265 40.3444 42.1731 42.9684 39.2982 44.6356L43.9994 52.774C51.5409 48.4125 55.9994 40.7597 55.9994 32.193C55.9994 30.9733 55.9095 30.1013 55.7297 29.1195C55.593 28.3735 54.9454 27.8271 54.1871 27.8271Z",
    fill: "#167EE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0005 46.6086C26.6048 46.6086 21.8945 43.6606 19.3646 39.2981L11.2266 43.9888C15.368 51.1665 23.1262 55.9999 32.0005 55.9999C36.354 55.9999 40.4618 54.8278 44.0005 52.7851V52.7739L39.2992 44.6355C37.1488 45.8827 34.6603 46.6086 32.0005 46.6086Z",
    fill: "#12B347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 52.7851V52.7739L39.2987 44.6355C37.1483 45.8827 34.66 46.6087 32 46.6087V56C36.3535 56 40.4615 54.8278 44 52.7851Z",
    fill: "#0F993E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3913 32.0001C17.3913 29.3405 18.1171 26.8523 19.3641 24.7019L11.226 20.0112C9.17206 23.5388 8 27.6354 8 32.0001C8 36.3647 9.17206 40.4614 11.226 43.9889L19.3641 39.2982C18.1171 37.1479 17.3913 34.6597 17.3913 32.0001Z",
    fill: "#FFD500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0005 17.3913C35.5191 17.3913 38.751 18.6416 41.2754 20.7212C41.8982 21.2342 42.8033 21.1972 43.3738 20.6267L47.8054 16.1952C48.4526 15.5479 48.4065 14.4884 47.7151 13.8886C43.4856 10.2193 37.9824 8 32.0005 8C23.1262 8 15.368 12.8335 11.2266 20.0112L19.3646 24.7018C21.8945 20.3394 26.6048 17.3913 32.0005 17.3913Z",
    fill: "#FF4B26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2749 20.7212C41.8977 21.2342 42.8029 21.1972 43.3733 20.6267L47.8048 16.1952C48.452 15.5479 48.4059 14.4884 47.7146 13.8886C43.485 10.2193 37.9819 8 32 8V17.3913C35.5184 17.3913 38.7505 18.6416 41.2749 20.7212Z",
    fill: "#D93F21"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_375_14598"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.32c6284fe5c5c754c204ba2d8ce815ef.svg";
export { ForwardRef as ReactComponent };